(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/play/views/single-rows-container.js') >= 0) return;  svs.modules.push('/modules/keno/components/play/views/single-rows-container.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.keno=_svs.keno||{};
_svs.keno.components=_svs.keno.components||{};
_svs.keno.components.play=_svs.keno.components.play||{};
_svs.keno.components.play.templates=_svs.keno.components.play.templates||{};
svs.keno.components.play.templates.single_rows_container = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"boardSettingsRegion\"></div>\n<div id=\"boardContainerRegion\" class=\"grid-row\"></div>\n<div class=\"grid-row\">\n  <div id=\"rowsRegion\" class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2\"></div>\n</div>\n<div id=\"campaignCardRegion\" class=\"grid-row margin-top\"></div>\n";
},"useData":true});
Handlebars.partials['svs-keno-components-play-single_rows_container'] = svs.keno.components.play.templates.single_rows_container;
})(svs, Handlebars);


 })(window);